import { Box, Typography } from '@mui/material'

const SingleInfo = ({ title, info, customStyle }) => (
  <Box sx={[styles.infoBox, customStyle]}>
    <Typography>{title}</Typography>
    <Typography>{info || '---'}</Typography>
  </Box>
)

const styles = {

  infoBox: {
    display: 'flex',
    justifyContent: 'space-between',
    '.MuiTypography-root': {
      fontSize: { xs: '12px', sm: '14px' },
      color: 'text.hint',
    },
  },
}

export default SingleInfo
